import styled from 'styled-components';
import { sizeVars } from '@routific/hive/v5';

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizeVars.gap.raised};
  text-align: center;
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${sizeVars.space[100]};
  max-width: 100%;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${sizeVars.gap.raised};
`;

// Figma sizes the modal illustration at 200px square. The Hive illustration
// fills its container, so the box is what sets the size.
export const IllustrationBox = styled.div`
  flex-shrink: 0;
  width: 200px;
  height: 200px;
`;
